/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 23.05.2016.
 */

import EPGClassicView from './epg-classic-view';

export default EPGClassicView;



// WEBPACK FOOTER //
// ./src/containers/EpgClassicView/index.js